import { EventBus } from '@/plugins/event-bus'

const moduleState = {
  customerTypes: [],
}

const getters = {
  all: (state) => state.customerTypes,
}

const mutations = {
  setCustomerTypes: (state, data) => {
    state.customerTypes = data
    EventBus.$emit('customerTypes/all')
  },
}

const actions = {
  setCustomerTypes({ commit }, types) {
    commit('setCustomerTypes', types)
  },
}

export default {
  state: moduleState,
  getters,
  mutations,
  actions,
  namespaced: true,
}
